import lrSelectPanel from './_src/lrSelectPanel.vue'

lrSelectPanel.install = function(Vue) {
  Vue.component(lrSelectPanel.name, lrSelectPanel)
}

export default lrSelectPanel